// TourPrompt — the one question the tour asks before it does anything.
//
// Deliberately the LAST thing to appear on a first launch: TourContext holds it
// back until the license, login and onboarding modals are all done (App.jsx
// drives that via setDeferPrompt). "Not now" is remembered, so nobody gets
// asked twice — the settings gear replays it on demand.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTour } from '../../contexts/TourContext';
import './Tour.css';

function TourPrompt() {
  const { t } = useTranslation('tour');
  const { start, decline } = useTour();

  return (
    <div className="pse-tour-prompt-backdrop" role="dialog" aria-modal="true" aria-labelledby="pse-tour-prompt-title">
      <div className="pse-tour-prompt">
        <div className="pse-tour-prompt-glow" />
        <div className="pse-tour-prompt-icon" aria-hidden="true">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 17v-5" />
            <circle cx="12" cy="8" r="0.6" fill="currentColor" />
          </svg>
        </div>

        <h2 id="pse-tour-prompt-title" className="pse-tour-prompt-title">{t('prompt.title')}</h2>
        <p className="pse-tour-prompt-body">{t('prompt.body')}</p>

        <div className="pse-tour-prompt-actions">
          <button type="button" className="pse-tour-btn pse-tour-btn-ghost" onClick={decline}>
            {t('prompt.no')}
          </button>
          <button type="button" className="pse-tour-btn pse-tour-btn-primary" onClick={start} autoFocus>
            {t('prompt.yes')}
          </button>
        </div>

        <p className="pse-tour-prompt-foot">{t('prompt.replayHint')}</p>
      </div>
    </div>
  );
}

export default TourPrompt;
